import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import { Button, CardActions, CardContent } from '@mui/material';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AnimatedCard, AnimatedTypography } from '../../../MotionMui/MotionMui';
import { TeamContext } from '../../TeamContext';
import { NewsCardProps } from '../TeamNewsList';
export const NewPackNewsCard = (props: NewsCardProps) => {
  const teamContext = useContext(TeamContext);
  const history = useHistory();

  if (teamContext.getUnopenedPacks().length === 0) {
    return <></>;
  }

  return props.parent(
    <AnimatedCard staggerSpeed={'Fast'}>
      <CardContent>
        <AnimatedTypography variant="h5" component="div">
          New Packs <ViewCarouselIcon />
        </AnimatedTypography>
        <AnimatedTypography variant="body2">
          {teamContext.getUnopenedPacks().length === 1
            ? 'You have a new pack to open'
            : `You have ${teamContext.getUnopenedPacks().length} new packs to open`}
        </AnimatedTypography>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          onClick={() => {
            history.push(`${teamContext.getBaseUrl()}/news/packs`);
          }}
        >
          View now
        </Button>
      </CardActions>
    </AnimatedCard>
  );
};
